import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { ZoneId } from '@js-joda/core';
export class Courthouse {
    /**
     * A building that contains one or more courtrooms where hearings take place
     * @param id Identifies the courthouse
     * @param name The name of the courthouse
     * @param courtSystemId Court system the courthouse belongs to
     * @param courtrooms A list of courtrooms that have been registered for the courthouse
     * @param timeZoneId The time zone specified for this courthouse
     */
    constructor(id, name, courtSystemId, courtrooms, timeZoneId) {
        this.id = id;
        this.name = name;
        this.courtSystemId = courtSystemId;
        this.courtrooms = courtrooms;
        this.timeZoneId = timeZoneId;
    }
}
__decorate([
    Serialize(() => ZoneId),
    __metadata("design:type", Object)
], Courthouse.prototype, "timeZoneId", void 0);
